import './Inicio.css';
import { Container, Grid, Link } from "@mui/material";
import FormInicio from './FormInicio';
import siempre from '../../assets/landing/Siempre-a-tu-lado.svg';
import encuentra from '../../assets/landing/Encuentra-el-mejor-seguro.svg';
import personaliza from '../../assets/landing/Personaliza-tu-seguro.svg';
import unSoloLugar from '../../assets/landing/Tus-seguros-en-un-solo-lugar.svg';
import fondo from '../../assets/landing/Medico-Desk.jpg';
import fondoMobile from '../../assets/landing/Medico-Mobile.jpg';
import seguro from '../../assets/landing/Medico-seguro.svg';
import check from '../../assets/landing/Check.svg';
import googlePlay from '../../assets/landing/Google-play.svg';
import appleStore from '../../assets/landing/App-Store.svg';
import mascotaSegura from '../../assets/landing/Mascota-segura.svg';
import cocheSeguro from '../../assets/landing/Coche-seguro.svg';
import vidaSegura from '../../assets/landing/Vida-segura.svg';
import bienSeguro from '../../assets/landing/Bien-seguro.svg';
import viajeSeguro from '../../assets/landing/viaje-seguro.svg';
import Header from '../Commons/Header';
import { plans } from './Plans';
import PreguntasFrecuentes from './PreguntasFrecuentes';
import FormInicioCotizacion from './FormInicioCotizacion';
import { useState } from 'react';

var fondoStyle = {
  minHeight: "700px",
  height: "100%",
  backgroundImage: `url(${fondo})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  position: 'relative',
};
var fondoStyleMobile = {
  height: "900px",
  backgroundImage: `url(${fondoMobile})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  position: 'relative',
};

export default function Inicio(props) {
  const [tipoForm, setTipoForm] = useState(false);
  const handleTipoForm = (value) => {
    setTipoForm(value);
  }

  return (
    <>
      <div style={(props.isMobile ? fondoStyleMobile : fondoStyle)}>
        <Header isMobile={props.isMobile} isFromInicio={true}></Header>
        <Container maxWidth="lg" className="container-inicio">
          <Grid container direction="row">
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Grid container direction="row" justifyContent="center" alignItems="left" spacing={1} rowSpacing={1}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'block', xl: 'block' } }}>&nbsp;</Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>&nbsp;</Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>&nbsp;</Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
                  <div className="logo-text">
                    <img src={seguro} alt='' />
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
                  <div className="logo-seguro">
                    Seguro, seguro
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
                  <div className="texto-logo">
                    Somos el mejor compa&ntilde;ro para elegir tu plan de salud ideal.
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>&nbsp;</Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <Grid container direction="column" justifyContent="center" alignItems="center" >
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'block', xl: 'block' } }}>&nbsp;</Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'block', xl: 'block' } }}>&nbsp;</Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>&nbsp;</Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="form-container">
                    <div className="form">
                      {tipoForm ?
                        <FormInicioCotizacion handleTipoForm={handleTipoForm} />
                        :
                        <FormInicio handleTipoForm={handleTipoForm} />
                      }
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>&nbsp;</Grid>
          </Grid>
        </Container>
      </div>
      <Grid container direction="row" justifyContent="center" alignItems="center" className="cinturon">
        <div className="cinturon-text">Aprovecha meses sin intereses todo el a&ntilde;o con tarjetas participantes.</div>
      </Grid>
      <div className="circulo-inicio-gde">
        <div className="circulo-inicio"></div>
      </div>
      <Grid container direction="row" justifyContent="center" className="landing-body">
        <Container maxWidth="lg" className="container-inicio">
          <div className="titulo-seccion mX-30">¿Por qu&eacute; INTER?</div>
          <Grid container direction="row" justifyContent="center" alignItems="center" spacing={4}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Grid container direction="row" alignItems="center" justifyContent="center" className="box">
                <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>
                  &nbsp;
                </Grid>
                <Grid item xs={12} sm={4} md={3} lg={3} xl={3} className="text-align-center">
                  <img src={siempre} alt='' />
                </Grid>
                <Grid item xs={12} sm={7} md={7} lg={7} xl={7}>
                  <div className="titulo-box-text">
                    Siempre a tu lado
                  </div>
                  <div className="desc-box-text">
                    Vive una experiencia personalizada y disfruta la tranquilidad de sentirte protegido, escuchado y <strong>respaldado de principio a fin.</strong>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} lg={1} xl={1}>
                  &nbsp;
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Grid container direction="row" alignItems="center" justifyContent="center" className="box">
                <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>
                  &nbsp;
                </Grid>
                <Grid item xs={12} sm={4} md={3} lg={3} xl={3} className="text-align-center">
                  <img src={encuentra} alt='' />
                </Grid>
                <Grid item xs={12} sm={7} md={7} lg={7} xl={7}>
                  <div className="titulo-box-text">
                    Encuentra el mejor seguro
                  </div>
                  <div className="desc-box-text">
                    Cotiza con las aseguradoras l&iacute;deres y obt&eacute;n <strong>el mejor plan al mejor precio,</strong> de forma f&aacute;cil, r&aacute;pida y segura.
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>
                  &nbsp;
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Grid container direction="row" alignItems="center" justifyContent="center" className="box">
                <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>
                  &nbsp;
                </Grid>
                <Grid item xs={12} sm={4} md={3} lg={3} xl={3} className="text-align-center">
                  <img src={personaliza} alt='' />
                </Grid>
                <Grid item xs={12} sm={7} md={7} lg={7} xl={7}>
                  <div className="titulo-box-text">
                    Personaliza tu seguro
                  </div>
                  <div className="desc-box-text">
                    Elige la mejor <strong>cobertura</strong> para ti y la forma de <strong>pago que m&aacute;s se ajuste a tus necesidades.</strong>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>
                  &nbsp;
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Grid container direction="row" alignItems="center" justifyContent="center" className="box">
                <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>
                  &nbsp;
                </Grid>
                <Grid item xs={12} sm={4} md={3} lg={3} xl={3} className="text-align-center">
                  <img src={unSoloLugar} alt='' />
                </Grid>
                <Grid item xs={12} sm={7} md={7} lg={7} xl={7}>
                  <div className="titulo-box-text">
                    Tus seguros en un s&oacute;lo lugar
                  </div>
                  <div className="desc-box-text">
                    Contrata en l&iacute;nea tu seguro y <strong>obt&eacute;n tu p&oacute;liza</strong> en minutos <strong>llev&aacute;ndolas siempre contigo en nuestra app.</strong>
                  </div>
                  <div className="tiendas mt-15">
                    <Link
                      href='https://play.google.com/store/apps/details?id=grut.inter.mx'
                      target={'_blank'}
                    >
                      <img src={googlePlay} alt='' />
                    </Link>
                    <Link
                      href=' https://apps.apple.com/mx/app/intermx/id1548367767?l=en'
                      target={'_blank'}
                    >
                      <img src={appleStore} alt='' />
                    </Link>
                  </div>

                </Grid>
                <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>
                  &nbsp;
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <div className="titulo-seccion mX-30">Tenemos el mejor plan para ti</div>
          <Grid container direction="row" justifyContent="center" alignItems="center" spacing={2}>
            {plans.map((plan, i) => ( //
              <Grid key={i} item xs={12} sm={6} md={6} lg={3} xl={3}>
                <Grid container direction="column" alignItems="center" className="box">
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
                    <div className="plans">
                      <div className="titulo-plans">
                        {plan.titulo}
                      </div>
                      <hr />
                      <div className="desc-plans">
                        {plan.detalle.map((detalle, j) => (
                          <Grid key={j} container direction="row" alignItems="center" className="mX-15">
                            <Grid item xs={1} md={1} lg={1} xl={1}>
                              <img src={check} alt='' />
                            </Grid>
                            <Grid item xs={11} md={11} lg={11} xl={11}>
                              {detalle.desc}<strong>{detalle.valor}</strong>
                            </Grid>
                          </Grid>
                        ))}
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Grid>
          <PreguntasFrecuentes />

          <Grid container direction="row" justifyContent="center" alignItems="center" className="box mt-30 mb-1rem pb-1rem">
            <Grid item xs={12} md={12} lg={12} xl={12}>
              <div className="titulo-seccion mX-1rem">¿Quieres proteger algo m&aacute;s?</div>
            </Grid>
            <Grid item xs={12} md={12} lg={12} xl={12}>
              <div className="subtitulo-seccion mb-1rem">Tenemos estos seguros pensados para ti</div>
            </Grid>
            <Grid container direction="row" justifyContent="space-around" rowSpacing={{ xs: 1, sm: 1, md: 1, lg: 2, xl: 2 }}
              columnSpacing={{ xs: 1, sm: 1, md: 1, lg: 2, xl: 2 }} className="w-100">
              <Grid item xs={12} sm={6} md={6} lg={2} xl={2}>
                <Grid item xs={12} md={12} lg={12} xl={12} className="algo-mas w-100">
                  <Link
                    href='https://mascotasegura.inter.mx/seguro-mascota/landing'
                  >
                    <img src={mascotaSegura} alt='' />
                  </Link>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={2} xl={2}>
                <Grid item xs={12} md={12} lg={12} xl={12} className="algo-mas w-100">
                  <Link
                    href='https://cocheseguro.inter.mx/inicio'
                  >
                    <img src={cocheSeguro} alt='' />
                  </Link>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={2} xl={2}>
                <Grid item xs={12} md={12} lg={12} xl={12} className="algo-mas w-100">
                  <Link
                    href='https://productos.inter.mx/vida-segura'
                  >
                    <img src={vidaSegura} alt='' />
                  </Link>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={2} xl={2}>
                <Grid item xs={12} md={12} lg={12} xl={12} className="algo-mas w-100">
                  <Link
                    href='https://productos.inter.mx/bien-seguro'
                  >
                    <img src={bienSeguro} alt='' />
                  </Link>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={2} xl={2}>
                <Grid item xs={12} md={12} lg={12} xl={12} className="algo-mas w-100">
                  <Link
                    href='https://inter.mx/viaje-seguro'
                  >
                    <img src={viajeSeguro} alt='' />
                  </Link>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Grid>
    </>
  );
}